<template>
  <div id="app">
    <NavBar/> <!-- NavBar是底部导航栏，也作为路由出口，所有页面会在这里渲染 -->
  </div>
</template>

<script>
// import main from './components/MobileMain.vue'
import NavBar from './components/NavBar.vue';
export default {
  name: 'App',
  components: {
    NavBar
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
